export default __webpack_public_path__ + "static/usb_c_xr_charging_adapter_m-0d51286943196c075569cc74ce36ee61.png";